import React from "react";
import cx from "classnames";
import style from "./GreenTitle.module.scss";

const GreenTitle = ({children, caps = false}) => <div className={cx(style.title, {[style.caps]: caps})}>{children}</div>;

export default GreenTitle;
